import localForage from 'localforage';
import { MemDriver } from '#kv-storage/drivers/mem/driver';
import { KvStorageImpl } from '#kv-storage/kv-storage';
export const createMemKvStorage = async () => {
    await localForage
        .getDriver(MemDriver._driver)
        .catch(() => localForage.defineDriver(MemDriver));
    return new KvStorageImpl(MemDriver._driver, 'MemKvStorage');
};
export const createPersistentKvStorage = () => {
    return Promise.resolve(new KvStorageImpl(localForage.INDEXEDDB, 'LucidLinkStorage'));
};
